const Gender = {
  Male: "MALE",
  Female: "FEMALE",
  Other: "OTHER",
};

export default Object.freeze(Gender);
